import { useQuery } from "@tanstack/react-query";
import adminApiClient, {
  CollectionProductPageEngagementStats,
} from "../../api/admin";

export const useCollectionProductPageEngagement = (days: number) => {
  return useQuery<CollectionProductPageEngagementStats>({
    queryKey: ["collectionProductPageEngagement", days],
    queryFn: () => adminApiClient.getCollectionProductPageEngagement(days),
  });
};

export default useCollectionProductPageEngagement;
